import React, { useState } from 'react';
import './navbar.css';
import logo from "../../resources/logo.png"
import contactImg from "../../resources/contact.png"
import menu from "../../resources/menu.png"
import {Link} from 'react-scroll';


const Navbar = () => {
    const [showMenu, setShowMenu] = useState(false);
    return (
        <nav className="navbar">
            <img src = {logo} alt="Logo" className='logo'/>
            <div className="desktopMenu">
                <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem">Home</Link>
                <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-70} duration={500} className="desktopMenuListItem">About</Link>
                <Link activeClass='active' to='works' spy={true} smooth={true} offset={-70} duration={500} className="desktopMenuListItem">Tech Stacks</Link>
                <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem">Resume</Link>
            </div>
            <button className="desktopMenuBtn" onClick={() => {
                document.getElementById('ContactMeHeader').scrollIntoView({behavior: 'smooth'})
            }}>
                <img src={contactImg} alt="ContactImage" className="desktopMenuImg" />Contact Me
            </button>

            <img src = {menu} alt="Menu" className='mobMenu'onClick={()=>setShowMenu(!showMenu)} />
            <div className="navMenu" style={{display: showMenu? 'flex' : 'none'}}>
                <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="ListItem" onClick={()=>setShowMenu(false)}>Home</Link>
                <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-100} duration={500} className="ListItem" onClick={()=>setShowMenu(false)}>About</Link>
                <Link activeClass='active' to='works' spy={true} smooth={true} offset={-70} duration={500} className="ListItem" onClick={()=>setShowMenu(false)}>Tech Stacks</Link>
                <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-100} duration={500} className="ListItem" onClick={()=>setShowMenu(false)}>Contact Me</Link>
            </div>
        </nav>
    )
}

export default Navbar;